import { type HTMLAttributes, type ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

const commonRewardVariants = cva('', {
  variants: {
    size: {
      '40': 'size-10',
      '64': 'size-16',
    },
  },
});

type CommonRewardVarinatsType = VariantProps<typeof commonRewardVariants>;

interface CommonRewardProps
  extends CommonRewardVarinatsType,
    HTMLAttributes<HTMLDivElement> {
  bgVariant: 'blue' | 'yellow' | 'green' | 'purple';
  icon: { img: string; webp?: string; className?: string; alt: string };
  label?: () => ReactNode;
}

const rewardsBgMap = {
  'tgem': 'purple',
  'usd': 'green',
  'usdt': 'green',
  'dice': 'purple',
  'diamondTicket': 'blue',
  'goldTicket': 'yellow',
  'silverTicket': 'purple',
} as const;

export {
  type CommonRewardProps,
  commonRewardVariants,
  type CommonRewardVarinatsType,
  rewardsBgMap,
};
